import vueAdvisorSvc from "../../services/vueAdvisorSvc";

const state = {
  answers: {},
  answersUpdated: 0,
  colorMatches: {
    data: {},
    updated: 0,
  },
};

export const getters = {};

export const actions = {
  initAnswers({ dispatch, state }) {
    if (!Object.keys(state.answers).length) {
      dispatch('getAdvisorAnswers');
    }
  },

  getAdvisorAnswers({ commit }) {
    vueAdvisorSvc.getCustomerAnswers().then(res => {
      commit('setAnswers', res.data.answers);
    });
  },

  updateColorMatches({ commit }) {
    vueAdvisorSvc.getAllColorMatches().then(res => {
      commit('setColorMatches', res.data);
    });
  },

  isAdvisorComplete() {
    return vueAdvisorSvc.isAdvisorComplete().then(res => res.data.isComplete);
  },

  persistCustomerAnswers({ dispatch }, params) {
    return vueAdvisorSvc.persistCustomerAnswers({ answers: params })
      .then(() => dispatch('getAdvisorAnswers')); 
  }
};

export const mutations = {
  setAnswers(state, val) {
    state.answers = val;
    state.answersUpdated += 1;
  },

  setColorMatches(state, val) {
    state.colorMatches.data = val;
    state.colorMatches.updated += 1;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
